import { IK_PROCESS_STEPS } from 'cpool-constants';
import type { TEAM_CATEGORY } from 'cpool-constants';

import { type CategoryByUserId, findSlotHolder } from './assignedUsers';

export type AssignedUserSlot = { category: TEAM_CATEGORY | null; isActive: boolean; userId: string };

// slot holder per IK step in step order (stored slot category first); all others follow without a slot
export const getAssignedUserSlots = ({
    activeUserId,
    slotCategories = {},
    userCategories = {},
    userIds,
}: {
    activeUserId?: string | null;
    slotCategories?: CategoryByUserId;
    userCategories?: CategoryByUserId;
    userIds: string[];
}): AssignedUserSlot[] => {
    // a user holds at most one slot, even if their stored slot category and team category disagree
    const categorized = IK_PROCESS_STEPS.reduce<AssignedUserSlot[]>((slots, category) => {
        const freeUserIds = userIds.filter((id) => !slots.some((slot) => slot.userId === id));
        const userId = findSlotHolder({
            category,
            categoryByUserId: userCategories,
            slotCategories,
            userIds: freeUserIds,
        });
        return userId ? [...slots, { category, isActive: userId === activeUserId, userId }] : slots;
    }, []);
    const slotHolderIds = new Set(categorized.map(({ userId }) => userId));
    const withoutSlot = userIds
        .filter((id) => !slotHolderIds.has(id))
        .map((userId) => ({ category: null, isActive: userId === activeUserId, userId }));
    return [...categorized, ...withoutSlot];
};
